import { useEffect, useRef } from 'react';
import ServiceAPI from '../services/serviceapi';
import tokenService from '../services/tokenservice';
import { RESPONSE } from '../enums/response';

const INTERVALO_MS = 5 * 60 * 1000; // 5 minutos

export function useTokenRefresh() {
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const renovar = async () => {
    try {
      const response = await ServiceAPI.renovarToken();
      if (response?.codeResponse === RESPONSE.SUCESSO_LOGIN) {
        const { tkn, menu, usuario } = response.dataResponse;
        await tokenService.updateToken(tkn, menu, usuario);
      }
    } catch {
      // 401 já é tratado pelo ServiceAPI — redireciona para /login
    }
  };

  useEffect(() => {
    renovar(); // dispara imediatamente ao montar

    intervalRef.current = setInterval(renovar, INTERVALO_MS);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);
}